import { ConstantRoutes } from "../../../core/constantRoutes";
import AdminUploadConfigMain from "../adminUploadConfigMain/adminUploadConfigMain";

function AdminEngines() {
    return(<>
        <AdminUploadConfigMain type="engines" fileName="Engines.json" 
              label="Engines" path={ConstantRoutes.adminEnginesSettings}/>
    </>)
}

export default AdminEngines;